import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import Loading from 'src/assets/images/Loading.svg'
import Trns, { translateSingleString } from 'src/localization/Trns'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'
import { selectIsExtendBrand } from 'src/redux/selectors/session.selectors'
import { css } from 'styled-components'

interface LoadingBackgroundPageProps {
  className?: string
}

const LoadingBackgroundPage: React.FC<
  React.PropsWithChildren<LoadingBackgroundPageProps>
> = (props): React.ReactElement => {
  const isExtendBrand = useSelector(selectIsExtendBrand)
  const locale = useSelector(selectNullSafeLocaleFromState)

  return (
    <div
      className={props.className}
      data-testid={'loading'}
      css={css`
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      `}
    >
      {isExtendBrand && (
        <img
          css={css`
            height: 120px;
            width: 90px;
          `}
          alt={translateSingleString(locale, 'Loading')}
          src={Loading}
        />
      )}
      {!isExtendBrand && (
        <span
          css={css`
            ${getFontCss(
              16,
              themeConstants.colors.cta,
              styleConstants.fontFamilies.regular,
            )}
          `}
        >
          <Trns source={'Loading...'} />
        </span>
      )}
    </div>
  )
}

export default LoadingBackgroundPage
